import { ReactNode } from 'react';

import WanderingBoundarySettingsProviderContext from 'features/wandering-boundary-settings/providers/contexts/wandering-boundary-provider-context';
import useWanderingBoundarySettingsProviderState from 'features/wandering-boundary-settings/providers/states/wandering-boundary-settings-provider-state';

type Props = {
  children: ReactNode;
};

const WanderingBoundarySettingsProvider = ({ children }: Props): React.JSX.Element => (
  <WanderingBoundarySettingsProviderContext.Provider value={useWanderingBoundarySettingsProviderState()}>
    {children}
  </WanderingBoundarySettingsProviderContext.Provider>
);

export default WanderingBoundarySettingsProvider;
